import {Injectable} from '@angular/core';

import {environment} from '../../environments/environment';

export const lambdaPrefix = {
    employee: environment.production ? 'employee/' : '',
    mobileBadging: environment.production ? 'mobilebadging/' : '',
};

@Injectable()
export class ApiConfig {
    static readonly PhotoReview = {
        getPhotoReviewGrid: `${environment.baseUrl}${lambdaPrefix.employee}api/PhotoReview/Range`,
        approvePhoto: `${environment.baseUrl}${lambdaPrefix.employee}api/PhotoReview/ApprovePhoto`,
        declinePhoto: `${environment.baseUrl}${lambdaPrefix.employee}api/PhotoReview/DeclinePhoto`,
        resubmissionPending: `${environment.baseUrl}${lambdaPrefix.employee}api/PhotoReview/ResubmissionPending`,
        furtherReviewPhoto: `${environment.baseUrl}${lambdaPrefix.employee}api/PhotoReview/FurtherReviewPhoto`,
        getSitesForBulkChangeSite: `${environment.baseUrl}${lambdaPrefix.employee}api/PhotoReview/GetSitesForBulkChangeSite`,
        bulkChangeSite: `${environment.baseUrl}${lambdaPrefix.employee}api/PhotoReview/BulkChangeSite`,
    };
    static readonly ImageRekognition = {
        detectFace: `${environment.baseUrl}${lambdaPrefix.employee}api/ImageRekognition/DetectFace?UId={uid}`,
        detectVisitorFace: `${environment.baseUrl}${lambdaPrefix.employee}api/Visitor/ImageRekognition/DetectFace?UId={uid}`,
        croppPhoto: `${environment.baseUrl}${lambdaPrefix.employee}api/ImageRekognition/CroppPhoto`,
        croppPhotoBulk: `${environment.baseUrl}${lambdaPrefix.employee}api/ImageRekognition/CroppPhotoBulk`,
        autocroppingSettings: `${environment.baseUrl}${lambdaPrefix.employee}api/ImageRekognition/AutocroppingSettings`,

    };
    static Users = {
        getUserList: `${environment.baseUrl}${lambdaPrefix.employee}api/User/Range`,
        user: `${environment.baseUrl}${lambdaPrefix.employee}api/User`,
        byId: `${environment.baseUrl}${lambdaPrefix.employee}api/User/{userId}`,
        getUserRoles: `${environment.baseUrl}${lambdaPrefix.employee}api/User/Roles`,
        userPhoto: `${environment.baseUrl}${lambdaPrefix.employee}api/Photo/{userAlias}`,
    };

    static Account = {
        getUserData: `${environment.baseUrl}${lambdaPrefix.employee}api/User`,
        signOut: `${environment.baseUrl}${lambdaPrefix.employee}api/SignOut`,
    };

    static UserManagement = {
        getGridOfUser: `${environment.baseUrl}${lambdaPrefix.employee}api/Employee/Range`,
        exportGridOfUser: `${environment.baseUrl}${lambdaPrefix.employee}api/Employee/Range/Export`,
        getEmployeeRequestGrid: `${environment.baseUrl}${lambdaPrefix.employee}/api/Employee/Request/Range`,
        searchEmployee: `${environment.baseUrl}${lambdaPrefix.employee}api/Employee/Search`,
        searchOnBehalf: `${environment.baseUrl}${lambdaPrefix.employee}api/Employee/SearchOnBehalf`,
        searchEmployeeInLocation: `${environment.baseUrl}${lambdaPrefix.employee}api/Employee/SearchInMyLocation`,
        searchPPMDEmployee: `${environment.baseUrl}${lambdaPrefix.employee}api/Employee/SearchPPMD`,
        searchPPMDPrehire: `${environment.baseUrl}${lambdaPrefix.employee}api/Employee/SearchPPMDPrehire`,
        searchApproverEmployee: `${environment.baseUrl}${lambdaPrefix.employee}api/Employee/SearchApproverEmployee`,
        // Endpoint for Senior Manager role
        searchApproverSM: `${environment.baseUrl}${lambdaPrefix.employee}api/Employee/SearchSeniorManagerEmployee`,
        // Endpoint for IRC Approver
        searchApproverIRC: `${environment.baseUrl}${lambdaPrefix.employee}api/Employee/SearchIRCApproverManager`,
        // Endpoint for 3rd party contractor
        searchApprover3rdParty: `${environment.baseUrl}${lambdaPrefix.employee}api/Employee/SearchThirdPartyContractorApprover`,
        // Endpoint for Business Approver
        searchApproverBusiness: `${environment.baseUrl}${lambdaPrefix.employee}api/Employee/SearchBusinessApprover`,
        // Endpoint for T&I Approver
        searchApproverTI: `${environment.baseUrl}${lambdaPrefix.employee}api/Employee/SearchTIApprover`,
        // Endpoint for Work Permit Approvers (Business + T&I)
        getWorkPermitApprovers: `${environment.baseUrl}${lambdaPrefix.employee}api/Employee/GetWorkPermitApprovers`,

        addEmployee: `${environment.baseUrl}${lambdaPrefix.employee}api/Employee/Save`,
        removeEmployee: `${environment.baseUrl}${lambdaPrefix.employee}api/Employee/Delete`,
    };

    static Dictionary = {
        getRoles: `${environment.baseUrl}${lambdaPrefix.employee}api/Dictionary/Roles`,
        getAvailableSites: `${environment.baseUrl}${lambdaPrefix.employee}api/Dictionary/AvailableSites`,
        getRejectedPhotoReasons: `${environment.baseUrl}${lambdaPrefix.employee}api/Dictionary/RejectedPhotoReasons`,
        getSites: `${environment.baseUrl}${lambdaPrefix.employee}api/Dictionary/Sites`,
        getAllSites: `${environment.baseUrl}${lambdaPrefix.employee}api/Dictionary/GetAllSites`,
        getAllSitesRange: `${environment.baseUrl}${lambdaPrefix.employee}api/Dictionary/GetAllSitesRange`,
        getAllSitesRangeExport: `${environment.baseUrl}${lambdaPrefix.employee}api/Dictionary/GetAllSitesRange/Export`,
        getVisitorSites: `${environment.baseUrl}${lambdaPrefix.employee}api/Dictionary/VisitorSites`,
        getVisitorSitesAndClearances: `${environment.baseUrl}${lambdaPrefix.employee}api/Dictionary/VisitorSitesAndClearances`,
        getCountries: `${environment.baseUrl}${lambdaPrefix.employee}api/Dictionary/Countries`,
        getFunctions: `${environment.baseUrl}${lambdaPrefix.employee}api/Dictionary/Functions`,
        getCCureClearance: `${environment.baseUrl}${lambdaPrefix.employee}api/Dictionary/CCureClearance`,
        getBloodGroups: `${environment.baseUrl}${lambdaPrefix.employee}api/Dictionary/BloodGroups`,
        getAllServiceAreas: `${environment.baseUrl}${lambdaPrefix.employee}api/Dictionary/ServiceArea`,
        getAvailableServiceArea: `${environment.baseUrl}${lambdaPrefix.employee}api/Dictionary/AvailableServiceArea`
    };

    static readonly BadgeRequests = {
        approveBadgeRequest: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/ApproveRequest`,
        declineBadgeRequest: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/DeclineRequest`,
        cancelBadgeRequest: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/CancelRequest`,
        reissueBadgeRequest: `${environment.baseUrl}${lambdaPrefix.employee}api/VisitorBadgeRequest/Reissue`,
        extendBadgeValidity: `${environment.baseUrl}${lambdaPrefix.employee}api/VisitorBadgeRequest/ExtendValidity`,

        getBadgeRequestsGrid: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/Compliance/Range`,
        getMDFBadgeRequestsGrid: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/Compliance/MDF/Range`,
        exportMDFBadgeRequest: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/Compliance/MDF/Range/Export`,
        getMdfRequestById: `${environment.baseUrl}${lambdaPrefix.employee}api/VisitorBadgeRequest/Mdf`,
        mdfPhotoUpload: `${environment.baseUrl}${lambdaPrefix.employee}api/VisitorBadgeRequest/Mdf/PhotoUpload`,
        getDetailsByBadgeNo: `${environment.baseUrl}${lambdaPrefix.employee}api/VisitorBadgeRequest/Mdf/GetDetailsByBadgeNo`,
        canUpload: `${environment.baseUrl}${lambdaPrefix.employee}canUploadBadgeRequest`,
        canUploadVisitor: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/canUploadVisitorBadgeRequest`,
        getInfo: `${environment.baseUrl}${lambdaPrefix.employee}getBadgeRequestInfo`,
        getLostBadgeRequestById: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/Lost`,
        getStolenBadgeRequestById: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/Stolen`,
        getPhotoOnlyRequestById: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/PhotoOnly`,
        getContractIdCard: `${environment.baseUrl}${lambdaPrefix.employee}api/VisitorBadgeRequest/ContractId`,
        getMemberVisitorRequest: `${environment.baseUrl}${lambdaPrefix.employee}api/VisitorBadgeRequest/MemberFirm`,
        getNonDeloitte: `${environment.baseUrl}${lambdaPrefix.employee}api/VisitorBadgeRequest/NonDeloitte`,
        getCle: `${environment.baseUrl}${lambdaPrefix.employee}api/CleBadgeRequest`,

        getVisitorMatchCount: `${environment.baseUrl}${lambdaPrefix.employee}api/Visitor/Match/Count`,
        getVisitorMatch: `${environment.baseUrl}${lambdaPrefix.employee}api/Visitor/Match`,
        verifyVisitor: `${environment.baseUrl}${lambdaPrefix.employee}api/Visitor/Verify`,
        /**
         * deprecated saveUpload
         */
        saveUpload: `${environment.baseUrl}${lambdaPrefix.employee}uploadBadgeRequest`,

        changeDeliveryLocation: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/ChangeDeliveryLocation`,
        uploadBadgeRequest: {
            badgeDamaged: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/Upload/BadgeDamaged`,
            badgeLost: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/Upload/BadgeLost`,
            contractId: `${environment.baseUrl}${lambdaPrefix.employee}api/VisitorBadgeRequest/ContractId/Upload`,
            contractIdCopy: `${environment.baseUrl}${lambdaPrefix.employee}api/VisitorBadgeRequest/ContractId/copy`,
            contractIdEdit: `${environment.baseUrl}${lambdaPrefix.employee}api/VisitorBadgeRequest/ContractId/edit`,
            nonDeloitte: `${environment.baseUrl}${lambdaPrefix.employee}api/VisitorBadgeRequest/NonDeloitte/Upload`,
            nonDeloitteCopy: `${environment.baseUrl}${lambdaPrefix.employee}api/VisitorBadgeRequest/NonDeloitte/copy`,
            nonDeloitteEdit: `${environment.baseUrl}${lambdaPrefix.employee}api/VisitorBadgeRequest/NonDeloitte/edit`,
            badgeStolen: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/Upload/BadgeStolen`,
            initialBadgeRequest: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/Upload/InitialBadgeRequest`,
            photoUpdate: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/Upload/PhotoUpdate`,
            memberVisitor: `${environment.baseUrl}${lambdaPrefix.employee}api/VisitorBadgeRequest/MemberFirm/Upload`,
            memberVisitorCopy: `${environment.baseUrl}${lambdaPrefix.employee}api/VisitorBadgeRequest/MemberFirm/copy`,
            memberVisitorEdit: `${environment.baseUrl}${lambdaPrefix.employee}api/VisitorBadgeRequest/MemberFirm/edit`,
            cleContractor: `${environment.baseUrl}${lambdaPrefix.employee}api/CleBadgeRequest/Upload`,
            cleContractorPhotoUpload: `${environment.baseUrl}${lambdaPrefix.employee}api/CleBadgeRequest/CreateBadgeRequest`,
            mdfCreateRequest: `${environment.baseUrl}${lambdaPrefix.employee}api/VisitorBadgeRequest/Mdf/CreateRequest`,
            mdfEdit: `${environment.baseUrl}${lambdaPrefix.employee}api/VisitorBadgeRequest/Mdf/Edit`,
            idfCreateRequest: `${environment.baseUrl}${lambdaPrefix.employee}api/VisitorBadgeRequest/IDF/CreateRequest`,
            idfEdit: `${environment.baseUrl}${lambdaPrefix.employee}api/VisitorBadgeRequest/IDF/Edit`,
        },
        /**
         * Badge status actions
         */
        readyToPickUp: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/ChangeBadgeStatus/ReadyToPickUp`,
        provided: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/ChangeBadgeStatus/Provided`,
        shippedTo: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/ChangeBadgeStatus/ShippedTo`,
        transferTo: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/ChangeBadgeStatus/Transfer`,
        suspendReminders: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/SuspendReminders`,
        lostInTransit: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/ChangeBadgeStatus/LostInTransit`,

        // TODO temporary solution
        ManualPromoteToCreatedInTransfer: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/ManualPromoteToCreatedInTransfer`,
        ManualPromoteToPrinting: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/ManualPromoteToPrinting`,
        // -------------


        /**
         * Badge status bulk actions
         */
        readyToPickUpBulk: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/ChangeBadgeStatus/Bulk/ReadyToPickUp`,
        providedBulk: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/ChangeBadgeStatus/Bulk/Provided`,
        shippedToBulk: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/ChangeBadgeStatus/Bulk/ShippedTo`,

        /**
         * Photo status actions
         */
        approved: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/ChangePhotoStatus/Approved`,
        resubmissionPending: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/ChangePhotoStatus/ResubmissionPending`,
        furtherReview: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/ChangePhotoStatus/FurtherReview`,
        cancel: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/ChangePhotoStatus/CancelRequest`,

        /**
         * Photo status bulk actions
         */
        approvedBulk: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/ChangePhotoStatus/Bulk/Approved`,
        resubmissionPendingBulk: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/ChangePhotoStatus/Bulk/ResubmissionPending`, //tslint:disable-line
        furtherReviewBulk: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/ChangePhotoStatus/Bulk/FurtherReview`,
        cancelBulk: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/ChangePhotoStatus/Bulk/CancelRequest`,

        exportBadgeRequest: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/Compliance/Range/Export`,
        deliveryLocations: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/GetDeliveryLocations`,

        /**
         * audit logs
         */
        getLogsGrid: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/AuditLog/Range`,
        //To get Prehire badge request details
        getPrehireBadgeRequestDetails: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/Prehire`,
    
        //
        getDeliveryLocationsByEmployee: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/GetDeliveryLocationsByEmployee`,
        isLastPhotoApproved: `${environment.baseUrl}${lambdaPrefix.employee}api/BadgeRequest/IsLastPhotoApproved`,
    };

    static File = {
        getUploadUrl: `${environment.baseUrl}${lambdaPrefix.employee}api/File/GetUploadUrl`,
        getDownloadUrl: `${environment.baseUrl}${lambdaPrefix.employee}api/File/{uId}/GetDownloadUrl`,
        getVisitorUploadUrl: `${environment.baseUrl}${lambdaPrefix.employee}api/File/Visitor/GetUploadUrl`,
        getVisitorDownloadUrl: `${environment.baseUrl}${lambdaPrefix.employee}api/File/Visitor/{uId}/GetDownloadUrl`,
        fileUrl: `${environment.baseUrl}${lambdaPrefix.employee}api/File/Download`,
        fileVisitorUrl: `${environment.baseUrl}${lambdaPrefix.employee}api/File/Visitor/Download`,
        deleteFile: `${environment.baseUrl}${lambdaPrefix.employee}api/File/Remove/{uId}`,
    };

    static Attachment = {
        getUploadUrl: `${environment.baseUrl}${lambdaPrefix.employee}api/File/VisitorDocuments/GetUploadUrl`,
        getDownloadUrl: `${environment.baseUrl}${lambdaPrefix.employee}api/File/VisitorDocuments/{uId}/GetDownloadUrl`,
        getDownload: `${environment.baseUrl}${lambdaPrefix.employee}api/File/VisitorDocuments/Download/{uId}`,
        addToVisitorRequest: `${environment.baseUrl}${lambdaPrefix.employee}api/VisitorBadgeRequest/Attachment`,
        deleteFromVisitorRequest: `${environment.baseUrl}${lambdaPrefix.employee}api/VisitorBadgeRequest/deleteattachment`,
        getVisitorRequestAttachments: `${environment.baseUrl}${lambdaPrefix.employee}api/VisitorBadgeRequest/Attachment`,
    };

    static readonly Employee = {
        getById: `${environment.baseUrl}${lambdaPrefix.employee}api/Employee/Profile`,
        requestRange: `${environment.baseUrl}${lambdaPrefix.employee}api/Employee/Request/Range`,
        cleRequestRange: `${environment.baseUrl}${lambdaPrefix.employee}api/Employee/CleRequest/Range`,
    };

    static readonly ManualActions = {
        sendCCurePrehireData: `${environment.baseUrl}${lambdaPrefix.employee}api/Admin/SendPrehireApprovedToCcure `,
        sendCCureEmplyeeData: `${environment.baseUrl}${lambdaPrefix.employee}api/Admin/SendEmployeeApprovedToCcure`,
    };

    static readonly Settings = {
        getSettings: `${environment.baseUrl}${lambdaPrefix.employee}api/Admin/Settings `,
        updateSettings: `${environment.baseUrl}${lambdaPrefix.employee}api/Admin/Settings `,
        configuration: `${environment.baseUrl}${lambdaPrefix.employee}api/Admin/FeaturesConfiguration`,
    };

    static readonly MobileBadging = {
        getRange: `${environment.baseUrl}${lambdaPrefix.mobileBadging}api/MobileBadging/Range`,
        approveMobileBadgeRequest: `${environment.baseUrl}${lambdaPrefix.mobileBadging}api/MobileBadging/ApproveMobileBadgeRequest `,
        isRequestAvailable:
            `${environment.baseUrl}${lambdaPrefix.mobileBadging}api/MobileBadging/{userId}/CheckMobileBadgeRequestAvailable`,
        saveMobileBadgeRequest: `${environment.baseUrl}${lambdaPrefix.mobileBadging}api/MobileBadging/SaveMobileBadgeRequest`,
        getMobileBadgeRequestInfo:
            `${environment.baseUrl}${lambdaPrefix.mobileBadging}api/MobileBadging/{userId}/GetMobileBadgeRequestInfo`,
        cancelMobileBadgeRequest: `${environment.baseUrl}${lambdaPrefix.mobileBadging}api/MobileBadging/CancelMobileBadgeRequest `,
        bulkApproveMobileBadgeRequest: `${environment.baseUrl}${lambdaPrefix.mobileBadging}api/MobileBadging/BulkApproveMobileBadgeRequest`,
        bulkCancelMobileBadgeRequest: `${environment.baseUrl}${lambdaPrefix.mobileBadging}api/MobileBadging/BulkCancelMobileBadgeRequest`,
    };

    static readonly BulkProvision = {
        getBulkProvisionGrid: `${environment.baseUrl}${lambdaPrefix.mobileBadging}api/MobileDevices/Range`,
        bulkPushAction: `${environment.baseUrl}${lambdaPrefix.mobileBadging}api/MobileDevices/BulkPushEmployeeMobileDevice`,
        bulkPushActionAll: `${environment.baseUrl}${lambdaPrefix.mobileBadging}api/MobileDevices/BulkPushAllEmployeeMobileDevice`,
        pushAction: `${environment.baseUrl}${lambdaPrefix.mobileBadging}api/MobileDevices/PushEmployeeMobileDevice`,
    };

    static readonly BulkVisitorUpload = {
        uploadNonDeloitteTemplate: `${environment.baseUrl}${lambdaPrefix.employee}api/TemplateParser/VisitorBadgeRequest/NonDeloitte`,
        uploadMemberFirmTemplate: `${environment.baseUrl}${lambdaPrefix.employee}api/TemplateParser/VisitorBadgeRequest/MemberFirm`,
        uploadContractorTemplate: `${environment.baseUrl}${lambdaPrefix.employee}api/TemplateParser/VisitorBadgeRequest/ContractId`,
        downloadNonDeloitteTemplate: `${environment.baseUrl}${lambdaPrefix.employee}api/TemplateParser/VisitorBadgeRequest/Template/NonDeloitte`,
        downloadMemberFirmTemplate: `${environment.baseUrl}${lambdaPrefix.employee}api/TemplateParser/VisitorBadgeRequest/Template/MemberFirm`,
        downloadContractorTemplate: `${environment.baseUrl}${lambdaPrefix.employee}api/TemplateParser/VisitorBadgeRequest/Template/ContractId`,
    }

    
    static readonly BulkCleContractorUpload = {
        uploadCleTemplate: `${environment.baseUrl}${lambdaPrefix.employee}api/TemplateParser/VisitorBadgeRequest/Cle`,
        uploadCleExtTemplate: `${environment.baseUrl}${lambdaPrefix.employee}api/TemplateParser/VisitorBadgeRequest/CleExtension`,
        downloadCleTemplate: `${environment.baseUrl}${lambdaPrefix.employee}api/TemplateParser/VisitorBadgeRequest/Template/Cle`,
        downloadCleExtTemplate: `${environment.baseUrl}${lambdaPrefix.employee}api/TemplateParser/VisitorBadgeRequest/Template/CleExtension`,
    }

    static readonly CleContractorSearch = {
        searchCleContractors: `${environment.baseUrl}${lambdaPrefix.employee}api/CleBadgeRequest/SearchContractor`,
    }

    static readonly EmployeeSearch = {
        fetchMyRequests: `${environment.baseUrl}${lambdaPrefix.employee}api/photo/searchrequests?alias=`,
        searchEmployee: `${environment.baseUrl}${lambdaPrefix.employee}api/photo/searchasync`,
        getMatchedDetails: `${environment.baseUrl}${lambdaPrefix.employee}api/photo/matchedDetails?requestId=`,
        checkAccessForEmployeeSearchTab: `${environment.baseUrl}${lambdaPrefix.employee}api/photo/checkaccess?email=`
    }

    
    static readonly RedirectUrls ={
        captivate: environment.captivateUrl,
    }

}
